export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <div className="logo" aria-label="tfGames.ai">
      <svg className="logo-mark" width="34" height="34" viewBox="0 0 34 34" aria-hidden="true">
        <defs>
          <linearGradient id="logo-gradient" x1="4" y1="3" x2="29" y2="31" gradientUnits="userSpaceOnUse">
            <stop stopColor="#B8A4FF"/><stop offset=".52" stopColor="#8B67F5"/><stop offset="1" stopColor="#F7618C"/>
          </linearGradient>
        </defs>
        <path d="M17 2.5 30 10v14L17 31.5 4 24V10L17 2.5Z" fill="url(#logo-gradient)"/>
        <path d="m17 7.5 7.7 4.4v8.9L17 25.2l-7.7-4.4v-8.9L17 7.5Z" fill="#11111B" fillOpacity=".88"/>
        <circle cx="17" cy="16.4" r="3.25" fill="url(#logo-gradient)"/>
        <path d="M17 8.1v5.1M24.2 12.2l-4.4 2.5M24.2 20.5 19.8 18M9.8 20.5l4.4-2.5M9.8 12.2l4.4 2.5" stroke="#DED5FF" strokeWidth="1.1" strokeLinecap="round"/>
      </svg>
      {!compact && <span className="logo-word">tfGames<span>.ai</span></span>}
    </div>
  );
}
